<footer class="border-top footer">
  <div style="margin: 0 auto 0 10px">{{ '© Copyright Volvo 2025' }}</div>
  <div style="margin: auto">
    {{ 'Valida + | Volvo do Brasil' }}
    @if (environmentName != 'production') {
      <span> - {{ environmentName }}</span>
    }
  </div>
  <div style="margin: 0 10px 0 auto">
    <a style="color: rgb(83, 86, 90)"
      href="https://www.volvogroup.com/"
      target="_blank"
      rel="noopener">
      www.volvogroup.com
    </a>
    |
    <a style="color: rgb(83, 86, 90)" href="https://www.volvogroup.com/en/tools/privacy.html">Privacy</a>
    |
    <a style="color: rgb(83, 86, 90)" href="https://www.volvogroup.com/en/tools/cookies.html">Cookies</a>
  </div>
</footer>
